<template>
  <v-card outlined>
    <v-card-title>Filtros</v-card-title>
    <v-row class="px-4 pb-0">
      <v-col cols="12" md="4">
        <CPTInput
          v-model="dadosForm.protocolo"
          clearable
          counter="12"
          label="Protocolo"
          type="number"
        />
      </v-col>
      <v-col cols="12" md="4">
        <CPTInput v-model="dadosForm.nome" clearable label="Nome" />
      </v-col>
      <v-col cols="12" md="4">
        <CPTSelect
          v-model="dadosForm.status"
          :items="tipoStatus"
          clearable
          item-text="label"
          label="Status"
        />
      </v-col>
    </v-row>
    <v-card-actions class="d-flex justify-end">
      <CPTBtn
        label="Buscar"
        icon="mdi-magnify"
        :loading="loading"
        @click="$emit('buscar', dadosForm)"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import CPTBtn from "@/components/Btn";
import CPTInput from "@/components/Input";
import CPTSelect from "@/components/Select";

const tipoStatus = [
  { label: "DEFERIDO", value: "DEFERIDO" },
  { label: "PENDENTE", value: "PENDENTE" },
  { label: "ELIMINADO", value: "ELIMINADO" },
  { label: "AGUARDANDO CORREÇÃO", value: "AGUARDANDO_CORRECAO" },
];

export default {
  name: "form-filtros",

  components: {
    CPTBtn,
    CPTInput,
    CPTSelect,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    dadosForm: {},
    tipoStatus,
  }),
};
</script>
